export default {"src":"/_next/static/media/coco-customer-service.66ff3635.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};